import React from 'react';

import Page from '../components/global/page';
import Hero from '../components/promo/hero';
import Content from '../components/promo/content';
import Video from '../components/promo/video';
import Gallery from '../components/promo/gallery';
import Sponsors from '../components/promo/sponsors';

export default ({ pageContext }) => {
	const { title, mastheadImage, logo, videoTitle, url, images } = pageContext;
	return (
		<Page title={title}>
			<Hero title={title} src={mastheadImage} logo={logo} />
			<Content
				title={title}
				data={{
					content: {
						title: pageContext.contentTitle,
						copy: pageContext.contentCopy,
					},
					columns: {
						title: pageContext.columnTitle,
						copy: pageContext.columnCopy,
						img: pageContext.columnImg,
					},
				}}
			/>
			{!!url ? <Video title={videoTitle} url={url} /> : null}
			{!!images && !!images.length ? (
				<Gallery title={title} images={images} />
			) : null}
			{/* <Sponsors /> */}
		</Page>
	);
};
